import React, { useCallback } from "react";
import { LiaEditSolid } from "react-icons/lia";
import { PiGraduationCap } from "react-icons/pi";

const Education = ({
  page,
  setIsOpen,
  setModalType,
  hesabimUserData,
  detayUserData,
}) => {
  const userData = page === "hesabim" ? hesabimUserData : detayUserData;
  const edu_cert = userData?.edu_cert || [];

  const handleEditClick = useCallback(() => {
    setModalType("Eğitim ve Sertifikalar");
    setIsOpen(true);
  }, [setModalType, setIsOpen]);

  return (
    <div className="detay-container">
      <div
        className={`flex items-center text-dark text-lg tracking-wide font-medium ${
          page === "hesabim" ? "flex-row-reverse justify-between" : "flex gap-3"
        }`}
      >
        <span>
          {page === "hesabim" ? (
            <LiaEditSolid
              className="size-[24px] text-grayy"
              onClick={handleEditClick}
            />
          ) : (
            <PiGraduationCap className="text-dark" />
          )}
        </span>
        <span>Eğitim ve Sertifikalar</span>
      </div>
      <div className="text-grayy text-sm pt-4">
        <ul className="list-disc ml-4">
          {!userData ? (
            <p>Yükleniyor...</p>
          ) : edu_cert.length > 0 ? (
            edu_cert.map((item, index) => (
              <li key={index} className="my-2 break-words">
                {item}
              </li>
            ))
          ) : (
            <p className="text-grayy text-sm">Henüz eklenmiş eğitim yok.</p>
          )}
        </ul>
      </div>
    </div>
  );
};

export default React.memo(Education);
